import {
  LoginView,
  SetPasswordView,
  ForgotPasswordView,
  ResetPasswordView,
} from '@/views/anonymous/auth';

export default [
  {
    path: '/login',
    name: 'app_auth_login',
    meta: { title: 'Log In', redirectAuthenticatedUsers: true, requiresAuthentication: false },
    component: LoginView,
  },
  {
    path: '/set-password',
    name: 'app_auth_set_password',
    component: SetPasswordView,
    meta: { redirectAuthenticatedUsers: true, requiresAuthentication: false },
  },
  {
    path: '/forgot-password',
    name: 'app_auth_forgot_password',
    meta: { title: 'Forgot Password', redirectAuthenticatedUsers: true, requiresAuthentication: false },
    component: ForgotPasswordView,
  },
  {
    path: '/reset-password',
    name: 'app_auth_reset_password',
    meta: { redirectAuthenticatedUsers: true, requiresAuthentication: false },
    component: ResetPasswordView,
  },
];
